import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const format_time_to_timezone = (date, timezone) => {
  let newDate = dayjs.utc(date).tz(timezone);
  return newDate;
};

export const same_time_in_timezone = (date, timezone) => {
  let time = dayjs(date).format("YYYY-MM-DD HH:mm");
  let newDate = dayjs.tz(time, timezone);

  return newDate;
};

export const formatted_date_for_backend = (date) => {
  if (date) {
    return date.toISOString();
  }

  return null;
};
